// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-NL';

import carVip from './carVip';

carVip(i18n);
